import { useState } from 'react';

import {
  AntaiFluxDto,
  AntaiWarningDto,
  SearchAntaiRecuperationEventResponseDto,
} from 'lib_api/lib/api/gen';

import {
  FetchDataResult,
  TablePagination,
  TableSort,
} from 'components/WrappedComponents/Table/types';
import { useApi } from 'hooks/ApiStoreContext';
import { backAlertMessage } from 'hooks/utils/backAlertMessage';
import { PAGINATION_DEFAULT } from 'utils/DashboardUtils';

import { ReferentielSearchType } from '../../Referentiels/Dashboards/utils';
import { FilterDashboardFlux, FilterDashboardFluxId } from '../types';

import { FluxAntaiSortOptions } from './types';

export function useSearchFluxAntai(
  filters: FilterDashboardFlux,
  sorts: TableSort<FluxAntaiSortOptions>,
  pagination: TablePagination,
): [
  () => Promise<SearchAntaiRecuperationEventResponseDto>,
  (
    result: SearchAntaiRecuperationEventResponseDto,
  ) => FetchDataResult<AntaiFluxDto>,
] {
  const controller = useApi().AdminFonctionnelControllerApi;

  return [
    () => {
      return controller.searchFluxUsingGET({
        sortDto: {
          dateDebut: sorts?.DATE_APPEL,
          indexDebut: sorts?.INDEX_DEBUT,
          indexFin: sorts?.INDEX_FIN,
        },
        page: pagination.page - 1,
        pageSize: pagination.pageSize,
      });
    },
    result => {
      return {
        data: result.flux,
        total: result.total,
      };
    },
  ];
}

export function useSearchWarningFluxsAntai(
  fluxId: string,
): ReferentielSearchType<AntaiWarningDto, FilterDashboardFluxId> {
  const [pagination, setPagination] =
    useState<TablePagination>(PAGINATION_DEFAULT);
  const [filter, setFilter] = useState<FilterDashboardFluxId>({});

  const controller = useApi().AdminFonctionnelControllerApi;

  return {
    fetchData: async () => {
      const result = await controller
        .warningsOfFluxUsingGET(fluxId || '', {
          page: pagination.page - 1,
          pageSize: pagination.pageSize,
        })
        .catch((e: Response) => {
          void backAlertMessage(e);
          throw e;
        });
      return {
        data: result.warnings,
        total: result.total,
      };
    },
    pagination: pagination,
    setPagination: newPagination => {
      setPagination(newPagination);
    },
    filter: filter,
    setFilter: setFilter,
    refreshDashboard: () => {
      setFilter(filter);
    },
  };
}
